export function getArticleExcerpt(article, maxLength = 180) {
  if (!article) return '';

  // 1. Use dedicated excerpt if available and not empty
  if (article.excerpt && article.excerpt.trim().length > 0) {
    const cleanExcerpt = stripHtml(article.excerpt);
    return truncateText(cleanExcerpt, maxLength);
  }

  // 2. Generate from content
  if (article.content) {
    const cleanContent = stripHtml(article.content);
    return truncateText(cleanContent, maxLength);
  }

  return '';
}

function stripHtml(html) {
  if (!html) return '';
  // Remove script and style tags completely
  let text = html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
  text = text.replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '');
  // Remove all other HTML tags
  text = text.replace(/<[^>]+>/g, ' ');
  // Normalize whitespace (replace multiple spaces/newlines with single space)
  text = text.replace(/\s+/g, ' ').trim();
  // Decode common HTML entities
  text = text.replace(/&nbsp;/g, ' ')
             .replace(/&amp;/g, '&')
             .replace(/&lt;/g, '<')
             .replace(/&gt;/g, '>')
             .replace(/&quot;/g, '"')
             .replace(/&#39;/g, "'");
  return text.trim();
}

function truncateText(text, maxLength) {
  if (!text || text.length <= maxLength) return text;

  // Try to find a space near the max length to avoid cutting a word in half
  const truncated = text.substring(0, maxLength);
  const lastSpace = truncated.lastIndexOf(' ');

  if (lastSpace > maxLength * 0.7) {
    // If we found a space in the last 30% of the string, cut there
    return truncated.substring(0, lastSpace).replace(/[.,;:]$/, '') + '…';
  }
  
  // Otherwise just cut hard and add ellipsis
  return truncated.replace(/[.,;:]$/, '') + '…';
}
